/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponse,
  GetApiV1PersonSharedFinancialPaymentMethodDropdown401,
  GetApiV1PersonSharedFinancialPaymentMethodDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedFinancialPaymentMethodDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedFinancialPaymentMethodDropdown } from "../../clients/personSharedController/getApiV1PersonSharedFinancialPaymentMethodDropdown.ts";

export const getApiV1PersonSharedFinancialPaymentMethodDropdownQueryKey = () =>
  [{ url: "/api/v1/person/shared/financial-payment-method-dropdown" }] as const;

export type GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryKey =
  ReturnType<typeof getApiV1PersonSharedFinancialPaymentMethodDropdownQueryKey>;

export function getApiV1PersonSharedFinancialPaymentMethodDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedFinancialPaymentMethodDropdownQueryKey();
  return queryOptions<
    GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedFinancialPaymentMethodDropdown401
      | GetApiV1PersonSharedFinancialPaymentMethodDropdown500
    >,
    GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedFinancialPaymentMethodDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as opções do enumerador EPersonFinancialPaymentMethod para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de formas de pagamento financeiro pessoal para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/financial-payment-method-dropdown}
 */
export function useGetApiV1PersonSharedFinancialPaymentMethodDropdown<
  TData = GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponse,
  TQueryData = GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedFinancialPaymentMethodDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedFinancialPaymentMethodDropdown401
          | GetApiV1PersonSharedFinancialPaymentMethodDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedFinancialPaymentMethodDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1PersonSharedFinancialPaymentMethodDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedFinancialPaymentMethodDropdown401
      | GetApiV1PersonSharedFinancialPaymentMethodDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
